module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAjElEQVR4AWOgE5hJJKKbhjNI6DQYnefjO8/LC2KjyqJrOM/Pf1lVFajoflzcvbg4IOOKujpQM04Nd0NDX8+c+TA39+3y5W+XLHmUlfV69uzbPj44NdyPjf166tTPR4++nDz5Bch48gRI3vH3x6nh7dKl3y5e/PngwbcrV4AIqBPIfT1rFlTB4IyHQQkAkJOPmIDwbS0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KH.png
// module id = 1180
// module chunks = 0